module.exports = __webpack_public_path__ + "img/tick_done.e474a5e9.svg";